import React from "react";
import NFLookupEmptyForms from "../../../../Shared/NewForms/NFLookupEmptyForms";

function GoodsTransfersOrdersGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default GoodsTransfersOrdersGenericSkeleton;
